import React, { useState, useEffect } from "react";
import { Row, Col } from "reactstrap";
import Card from "../Component/Mixern/Card";
import Headings from "../Component/Mixern/Headings";
import { useAuth } from "../Context/AuthContext";
import { useSelector, useDispatch } from "react-redux";
import { setCurrentPage } from "../Redux/Actions/activePage";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import ImportFromYear from "../Component/Mixern/ImportFromYear";
import useWindowSize from "../Component/use-window-size";
import CardMobile from "../Component/Mixern/CardMobile";

export default function Mixern() {
  const { data, setData, currentUser, postLocalData } = useAuth();

  const [headingFocused, setHeadingFocused] = useState(false);
  const [draggableOrder, setDraggableOrder] = useState(data);
  const [input] = useState({
    category: "",
    product: "",
    price: "0",
    variableCost: "0",
    volumeYear: "0",
    workHours: "0",
  });
  //get current windowsize
  const size = useWindowSize();
  //redux
  const dispatch = useDispatch();
  const activeYear = useSelector((state) => state.year.year);
  const sizeForMobile = useSelector((state) => state.sizeForMobile.size);

  function submitHandler() {
    postLocalData(input);
  }

  //if rows in mixer less than 1 add rows
  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      const setRowsIfMissing =
        data && data.data.filter((item) => item.year === activeYear).length;
      if (setRowsIfMissing < 1) {
        const delayEditData = setTimeout(() => {
          //small delay when last row is deleted and new rows appear
          postLocalData(input);
        }, 500);
        return () => clearTimeout(delayEditData);
      }
    }
    return () => {
      isMounted = false;
    };
  }, [activeYear, data, input, postLocalData]);

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      dispatch(setCurrentPage("Produktmixern"));
    }
    return () => {
      isMounted = false;
    };
  }, [activeYear, dispatch, currentUser]);

  function handleOnDragEnd(result) {
    //return nothing if dragged object has no destination (dropped out of range)
    if (!result.destination) return;
    const items = Array.from(draggableOrder.data);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    setDraggableOrder({ data: items });
    setData({ data: items });
  }

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      setDraggableOrder(data);
    }
    return () => {
      isMounted = false;
    };
  }, [data]);

  return (
    <Row className="mt-5">
      <Col xs={40} className="m-auto g-0">
        {/* hide if under 1024 width */}
        {size.width < sizeForMobile ? (
          ""
        ) : (
          <Headings headingFocused={headingFocused} />
        )}

        <div
          className={
            size.width < sizeForMobile ? "scrollbox-mobile" : "scrollbox"
          }
        >
          <DragDropContext onDragEnd={handleOnDragEnd}>
            <Droppable droppableId="cardOrder">
              {(provided) => (
                <div
                  className="content-wrapper"
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                >
                  {draggableOrder &&
                    draggableOrder.data
                      .filter((item) => item.year === activeYear)
                      .map((card, index) => (
                        <Draggable
                          key={card.id}
                          draggableId={card.id}
                          index={index}
                        >
                          {(provided) => (
                            <div
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              ref={provided.innerRef}
                            >
                              {size.width < sizeForMobile ? (
                                <CardMobile data={card} />
                              ) : (
                                <Card
                                  data={card}
                                  setHeadingFocused={setHeadingFocused}
                                />
                              )}
                            </div>
                          )}
                        </Draggable>
                      ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </div>
        <div className="container-buttons-below-scrollbox">
          <div className="button-add-row" onClick={submitHandler}>
            <p className="plus">+</p>
          </div>
          {size.width < sizeForMobile ? "" : <ImportFromYear />}
        </div>
      </Col>
    </Row>
  );
}
